import { Home, Calendar, FileText, Clock, Book, Percent } from 'lucide-react';

export const student = [
    { icon: <Home />, text: "Dashboard", path: "dashboard" },
    { icon: <Calendar />, text: "Attendance", path: "attendance" },
    { icon: <FileText />, text: "DocVault", path: "docvault" },
    { icon: <Clock />, text: "TimeTable", path: "timetable" },
    { icon: <Book />, text: "Almanac", path: "almanac" },
    { icon: <Percent />, text: "Scores", path: "scores" },
];